import React from 'react'
import agent from '../agent'
import Loading from './widgets/Loading'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {
    MASTER_ACCOUNT_DETAIL_LOADED,
    ACCOUNT_NEXT_PAGE_LOADED,
    MASTER_ACCOUNT_DETAIL_UNLOADED
} from '../constants/actionTypes'
import dateHelper from '../util/dateFormatter'
import numberHelper from '../util/numberFormatter'
import TransactionList from './widgets/TransactionList';
import Pager from 'react-pager'

const mapStateToProps = state => ({
    ...state.account,
    currentUser: state.common.currentUser
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload, pageIndex) =>
        dispatch({ type: MASTER_ACCOUNT_DETAIL_LOADED, payload, currentPage: pageIndex }),
    onLoadNextPage: (payload, pageIndex) =>
        dispatch({ type: ACCOUNT_NEXT_PAGE_LOADED, payload, currentPage: pageIndex }),
    onUnload: () =>
        dispatch({ type: MASTER_ACCOUNT_DETAIL_UNLOADED })
});

class MasterAccountDetail extends React.Component {
    componentWillMount() {
        const pageIndex = 1;
        const payload = agent.Accounts.getMasterAccountDetail(this.props.match.params.key, pageIndex, '')
        this.props.onLoad(payload, pageIndex);
    }
    handlePageChanged(newPage) {
        //start page = 0
        const pageIndex = newPage + 1;
        this.setState({ pageIndex: pageIndex })
        const payload = agent.Accounts.getMasterAccountDetail(this.props.match.params.key, pageIndex, '')
        this.props.onLoadNextPage(payload, pageIndex);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {
        if (!this.props.account) {
            return (
                <Loading />
            )
        }
        return (
            <div class='pane'>
                <Link className="crumb" to="/masteraccounts">&laquo; back to master accounts</Link>

                <h1>Account Detail</h1>
                <div className="infoGroup">
                    <div className="infoPair">
                        <label>Key:</label> <span><Link to={`/masteraccounts/${this.props.account.key}/update`}>{this.props.account.key} </Link></span>
                    </div>
                    <div className="infoPair">
                        <label>Created:</label> <span>{dateHelper.Formatter.toLocalString(this.props.account.created)}</span>
                    </div>
                    <div className="infoPair">
                        <label>Symbol:</label> <span>{this.props.account.symbol}</span>
                    </div>
                    <div className="infoPair">
                        <label>Name:</label> <span>{this.props.account.name}</span>
                    </div>
                    <div className="infoPair">
                        <label>Type:</label> <span>{this.props.account.type}</span>
                    </div>
                    <div className="infoPair">
                        <label>External:</label> <span>{this.props.account.external}</span>
                    </div>
                    <div className="infoPair">
                        <label>Amount:</label> <span>{numberHelper.Formatter.toDecimal(this.props.account.amount)}</span>
                    </div>
                    <div className="infoPair">
                        <label>Amount locked:</label> <span>{numberHelper.Formatter.toDecimal(this.props.account.amount_locked || 0)}</span>
                    </div>

                </div>
                <div className="infoGroup infoGroupGap">
                    <Link to={`/masteraccounts/${this.props.account.key}/mint`} className="buttonTextLite">Mint</Link>
                    <Link to={`/coins/send?address=${this.props.account.external}&key=${this.props.account.key}`} className="buttonTextLite">Send</Link>
                </div>
                <TransactionList transactions={this.props.account.transactions} loading={this.props.loading} accountkey={this.props.account.key} />
                {
                    this.props.account.transactions && this.props.account.transactions.length > 0 ?
                        <Pager
                            total={this.props.totalPage || 0}
                            current={this.props.currentPage - 1}
                            visiblePages={7}
                            titles={{ first: '<<', last: '>>' }}
                            onPageChanged={this.handlePageChanged.bind(this)}
                        />
                        : null
                }
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MasterAccountDetail);



// WEBPACK FOOTER //
// ./src/components/MasterAccountDetail.js